import React from 'react';
import { useTranslation } from 'react-i18next';

interface TaskInputProps {
  onSubmit: (content: string) => void;
}

export default function TaskInput({ onSubmit }: TaskInputProps) {
  const { t } = useTranslation();
  const [content, setContent] = React.useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;

    onSubmit(content);
    setContent('');
  };

  return (
    <form className="group" onSubmit={handleSubmit}>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <input
            className="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl
              focus:outline-none focus:ring-2 focus:ring-[#FFD66B] focus:border-transparent
              transition-all duration-200 placeholder:text-gray-400"
            placeholder={t('checklist.addTaskPlaceholder')}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />

        </div>
        <button
          className="bg-gray-900 flex items-center justify-center h-[42px] text-white px-6 rounded-xl
            hover:bg-gray-800 transition-all duration-200 font-medium shadow-sm
            hover:shadow-md active:scale-95"
          type="submit"
        >
          {t('common.add')}
        </button>
      </div>
    </form>
  );
}
